var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { cloneDeep } from 'lodash';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import HeaderItem from "../../../components/HeaderItem.vue";
import SupplierService from '../../../api/SupplierService';
import CommonService from '../../../api/CommonService';
import RegexStr from "../../../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.mobile);
var accountdatevalRules = {
    1: { numeric: true, min_value: 1, max_value: 31 },
    3: { numeric: true, min_value: 1, max_value: 28 },
    4: { date_format: 'YYYY-MM-DD' },
    6: { date_format: 'YYYY-MM-DD' },
    7: { numeric: true, min_value: 1, max_value: 7 },
    default: ''
};
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phoneRegex = phoneRegex;
        _this.form = {
            supplier_upper_name: '',
            supplier_upper_pinyin: '',
            supplier_upper_code: '',
            category_id: '',
            supplier_upper_area: null,
            supplier_upper_address: '',
            supplier_upper_contact: '',
            supplier_upper_phone: '',
            supplier_upper_email: '',
            finance_code: '',
            corporate_account: '',
            personal_account: '',
            payment_person: '',
            company_bank: '',
            company_bank_num: '',
            payment_account: '',
            subject_code: '',
            tax_ticket_type_id: '',
            accountdatetype: 1,
            accountdateval: 1,
            margin: '',
            statement_type: 1,
            personal_account_name: '',
            tax_no: '',
            company_tel_code: '',
            company_tel: ''
        };
        _this.organList = [];
        _this.categoryList = [];
        _this.areaList = [];
        _this.accountDatetypeList = [];
        _this.taxTicketTypeList = [];
        _this.statementTypeList = [
            {
                id: 1,
                name: '整体对账'
            },
            {
                id: 3,
                name: '多机构对账'
            },
            {
                id: 2,
                name: '多仓库对账'
            }
        ];
        _this.accountdatevalRule = accountdatevalRules[1];
        _this.selectDays = [];
        return _this;
    }
    AddDialog.prototype.accountdatetypeWatch = function (val, oldVal) {
        this.form.accountdateval = '';
        this.accountdatevalRule = accountdatevalRules[val] || accountdatevalRules['default'];
    };
    AddDialog.prototype.watchData = function (val, oldVal) {
        var detailData = this.detailData || {};
        detailData.tax_ticket_type_id = detailData.tax_ticket_type_id || '';
        var tel = String(detailData.company_tel || '-');
        if (tel && tel.length > 1) {
            detailData.company_tel_code = tel.split('-')[0],
                detailData.company_tel = tel.split('-')[1];
        }
        this.form = detailData;
        this.accountdatevalRule = accountdatevalRules[this.form.accountdatetype] || accountdatevalRules['default'];
    };
    AddDialog.prototype.created = function () {
        this.service = SupplierService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getCategory();
        this.getArea();
        this.getAccountDatetype();
        this.getTaxTicketType();
        var daysArr = [];
        for (var i = 1; i <= 28; i++)
            daysArr.push(i);
        this.selectDays = daysArr;
    };
    AddDialog.prototype.getOrganList = function () {
        var _this = this;
        var params = {
            is_all: 1
        };
        return this.service.getOrganList(params).then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
        });
    };
    AddDialog.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory({
            is_all: 1
        }).then(function (res) {
            _this.categoryList = res.data.data || [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getArea = function () {
        var _this = this;
        this.commonService.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                _this.areaList = data.data[0].children;
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.getAccountDatetype = function () {
        var _this = this;
        this.service.getAccountDatetype().then(function (res) {
            _this.accountDatetypeList = res.data.data || [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getTaxTicketType = function () {
        var _this = this;
        this.service.getTaxTicketType().then(function (res) {
            _this.taxTicketTypeList = res.data.data || [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.getPinyin = function (e) {
        var _this = this;
        var value = e.target.value;
        if (value) {
            this.service.getPinyin({ name: value }).then(function (res) {
                _this.form.supplier_upper_pinyin = res.data.data.pinyin;
            });
        }
        else {
            this.form.supplier_upper_pinyin = '';
        }
    };
    AddDialog.prototype.submitData = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            var form = cloneDeep(_this.form);
            if (!res) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            if (form.supplier_upper_phone && !phoneRegex.test(form.supplier_upper_phone)) {
                _this.$message.error('联系人手机号格式不正确！');
                return;
            }
            if (form.company_tel_code && form.company_tel) {
                form.company_tel = form.company_tel_code + "-" + form.company_tel;
            }
            _this.service.saveUpper(form).then(function (res) {
                _this.$emit('save:ok');
                _this.close();
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        });
    };
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return {};
            }
        })
    ], AddDialog.prototype, "detailData", void 0);
    __decorate([
        Watch("form.accountdatetype")
    ], AddDialog.prototype, "accountdatetypeWatch", null);
    __decorate([
        Watch("detailData")
    ], AddDialog.prototype, "watchData", null);
    AddDialog = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
